"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTemperatureFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M14 17.26V6a4 4 0 00-8 0v11.45A6.61 6.61 0 003 23a7 7 0 1011-5.74zM10 4a2 2 0 012 2v6H8V6a2 2 0 012-2zM19.99 4h8v2h-8zM19.99 10h5v2h-5zM19.99 16h8v2h-8zM19.99 22h5v2h-5z" })));
}
exports.default = SvgTemperatureFilled;
//# sourceMappingURL=TemperatureFilled.js.map